module.exports = require('./head');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/first.js
 ** module id = 905
 ** module chunks = 0
 **/